/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

import { animate, query, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';

@Component({
  selector: 'app-apps-layout',
  templateUrl: './apps-layout.component.html',
  animations: [
    trigger('architectUIAnimation', [
      transition('* <=> *', [
        query(':enter, :leave', [
          style({
            opacity: 0,
            display: 'flex',
            flex: '1',
            transform: 'translateY(-20px)',
            flexDirection: 'column',
          }),
        ]),
        query(':enter', [animate('600ms ease', style({ opacity: 1, transform: 'translateY(0)' }))]),

        query(
          ':leave',
          [animate('600ms ease', style({ opacity: 0, transform: 'translateY(-20px)' }))],
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class AppsLayoutComponent {
  constructor() {}
}
